import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';

const EmptyChatState = ({ selectedUser }) => {
  const theme = useTheme();
  const fullName = selectedUser
    ? `${selectedUser?.fname || ''} ${selectedUser?.lname || ''}`.trim()
    : null;

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        p: 4,
      }}
    >
      <Box
        sx={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          bgcolor: alpha(theme.palette.primary.main, 0.1),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <ChatBubbleOutlineIcon
          sx={{ fontSize: 36, color: 'primary.main', opacity: 0.7 }}
        />
      </Box>
      {fullName ? (
        <>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: 'text.primary',
              textAlign: 'center',
            }}
          >
            Start chatting with {fullName}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: 'text.secondary',
              textAlign: 'center',
              maxWidth: 300,
            }}
          >
            Send your first message to begin the conversation
          </Typography>
        </>
      ) : (
        <>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: 'text.primary',
              textAlign: 'center',
            }}
          >
            Select a conversation
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: 'text.secondary',
              textAlign: 'center',
              maxWidth: 300,
            }}
          >
            Choose from your paired users on the left to start chatting
          </Typography>
        </>
      )}
    </Box>
  );
};

export default EmptyChatState;
